import { Api, ICommentApi, ILikesApi } from '@api';
import {
  CommentParentEntityEnum,
  LikeParentEntityEnum,
} from '@constants';

export function getCommentApiByParentEntity(
  parentEntity: CommentParentEntityEnum,
): ICommentApi {
  const apiCollection = {
    [CommentParentEntityEnum.Post]: Api.Feed,
    [CommentParentEntityEnum.Tutorial]: Api.Hub,
    // TODO: replace by Api.Tracks
    [CommentParentEntityEnum.Track]: Api.Hub,
  };

  return apiCollection[parentEntity];
}

export function getLikeApiByParentEntity(
  parentEntity: LikeParentEntityEnum,
): ILikesApi {
  const apiCollection = {
    [LikeParentEntityEnum.Post]: Api.Feed,
    // TODO: replace by Api.Hub
    [LikeParentEntityEnum.Tutorial]: Api.Feed,
    // TODO: replace by Api.Tracks
    [LikeParentEntityEnum.Track]: Api.Feed,
  };

  return apiCollection[parentEntity];
}
